__turbopack_context__.v({
  "links": "footer-links-module-scss-module__2DE0Eq__links",
});
